import Cookie from 'js-cookie';

const isMockDataEnabled = () => {
  const raw = (process.env.JDX_APP_USE_MOCK_DATA ?? '').trim();
  if (!raw) return false;

  if (raw.startsWith('__JDX_MOCK_ON_')) return true;
  if (raw.startsWith('__JDX_MOCK_OFF_')) return false;

  return false;
};
export const getRequestHeader = () => {
  // 判断是否使用 mock 数据（通过环境变量控制）

  // 生产环境使用Cookie获取
  return {
    token: Cookie.get('token'),
    authType: Cookie.get('authType'),
    deviceId: Cookie.get('deviceId'),
    userAccount: Cookie.get('userName'),
    siteId: Cookie.get('siteId'),
    operatorId: Cookie.get('operatorId'),
    'LOP-DN': process.env.JDX_APP_LOP_DN!
  };
};
class BaseOptions {
  requestHeaders: any;
  fetchDomain: string;
  headerPriority?: 'default' | 'custom';
  constructor() {
    this.requestHeaders = getRequestHeader();
    this.fetchDomain = process.env.JDX_APP_LOP_DOMAIN!;
  }
}

export default BaseOptions;
